import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";


export const orderRequestsHeaders = [
    {
        id: 1,
        Header: "ID",
        accessor: "id",
        isChecked: true
    },
    {
        id: 2,
        Header: "Product Name",
        accessor: "product_name",
        isChecked: true
    },
    {
        id: 3,
        Header: "Date",
        accessor: (row: any) => new Date(row?.created_at),
        Cell: ({ row }: any) => {
            return (
                new Date(row.original.created_at).toLocaleDateString("de")
            );
        },
        isChecked: true
    },
    {
        id: 4,
        Header: "Commment",
        accessor: "comment",
        isChecked: true
    },
    {
        id: 5,
        Header: "Status",
        accessor: "status",
        Cell: ({ row }: any) => {
            return (
                <Status value={row.original.status} />
            );
        },
        isChecked: true
    },

];

const Status = ({ value }: any) => {
    const [Color, setColor] = useState<string>("");
    const { t } = useTranslation();


    useEffect(() => {
        switch (value) {
            case 'pending':
                setColor("#EFBE12");
                break;

            case 'approved':
                setColor("#2DE28B");
                break;
            case 'rejected':
                setColor("#CC7272");
                break;
        }

    }, [value, t]);

    const CapitalizedValue = useMemo(() => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }, [value])

    return (
        <span
            className={`text-[12px] bg-opacity-10 font-inter-light px-[8px] py-[3px] rounded-[4px] whitespace-nowrap`}
            style={{ background: Color + "1A", color: Color }}
        >
            {t(CapitalizedValue)}
        </span>
    );
};
